var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4433 1.09678C11.3658 1.01867 11.2736 0.956677 11.1721 0.91437C11.0705 0.872062 10.9616 0.850281 10.8516 0.850281C10.7416 0.850281 10.6327 0.872062 10.5311 0.91437C10.4296 0.956677 10.3374 1.01867 10.2599 1.09678L4.0516 7.31345L1.44327 4.69678C1.36283 4.61908 1.26788 4.55799 1.16384 4.51698C1.05979 4.47598 0.948688 4.45587 0.836871 4.45781C0.725053 4.45974 0.614712 4.48368 0.512147 4.52826C0.409582 4.57283 0.316801 4.63718 0.239102 4.71761C0.161403 4.79805 0.100308 4.893 0.0593049 4.99704C0.0183016 5.10109 -0.00180712 5.21219 0.000127432 5.32401C0.00206199 5.43583 0.0260018 5.54617 0.0705797 5.64873C0.115158 5.7513 0.179501 5.84408 0.259935 5.92178L3.45994 9.12178C3.53741 9.19989 3.62957 9.26188 3.73112 9.30419C3.83267 9.3465 3.94159 9.36828 4.0516 9.36828C4.16161 9.36828 4.27053 9.3465 4.37208 9.30419C4.47363 9.26188 4.5658 9.19989 4.64327 9.12178L11.4433 2.32178C11.5279 2.24374 11.5954 2.14903 11.6415 2.04362C11.6877 1.9382 11.7115 1.82436 11.7115 1.70928C11.7115 1.59419 11.6877 1.48036 11.6415 1.37494C11.5954 1.26952 11.5279 1.17481 11.4433 1.09678Z",
    fill: "#456EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d7376e59ef5a29db879dd71023e5261f.svg";
export { ForwardRef as ReactComponent };